"use client";

import { useTheme } from "@/lib/theme/them-provider";


export function Container({ children }: React.PropsWithChildren) {
  const { theme } = useTheme();

  return (
    <div
      style={{
        maxWidth: theme.spacing.container,
        margin: "0 auto",
        padding: `0 ${theme.spacing.md}px`,
      }}
    >
      {children}
    </div>
  );
}
